<template>
  <div>
    <!-- 客服 -->
    <div class="service" @click="showService">
      <img :src="require('@/assets/images/service.gif')" alt="">
    </div>
    <!-- 弹窗 -->
    <van-popup class="service-popup" v-model="showServicePopup" :close-on-click-overlay="false">
      <div class="service-popup__bd">
        <img src="http://mmcb-pub-static.mmcb.top/service-popup.png" alt="">
      </div>
      <div class="service-popup__close" @click="showServicePopup = false">
        <van-icon name="close" color="#fff" size="36" />
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Service',
  data() {
    return {
      showServicePopup: false
    }
  },
  mounted() {},
  methods: {
    showService() {
      this.showServicePopup = true

      // this.$zhuge.track('拼团加客服', { })
    }
  }
}
</script>

<style lang="scss" scoped>
  .service{
    padding: 0 15px;
    display: block;
    img{
      width: 100%;
    }
  }
  .service-popup{
    background: none;
    .service-popup__bd{
      img{
        width: 280px;
      }
    }
    .service-popup__close{
      text-align: center;
      margin-top: 15px;
    }
  }
</style>
